module.exports = __webpack_public_path__ + "static/Tania-Lyden-567f113469f3538708098866fa0eb46f.jpg";